if (document.querySelector("#livevue-Template")) {
  const timer = setInterval(() => {
    const rating = document.querySelector("#overallRatingBanner");
    const priceEl = document.querySelector('#larf-price');
    const heading = document.querySelector('.text-block h1');

    // ✅ Run ONLY when ready
    if (rating && priceEl && heading) {

      // Prevent duplicate wrapper
      if (!document.querySelector('.rating-heading-wrapper')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'rating-heading-wrapper';
        wrapper.style.margin = '0.5rem 0'
        wrapper.appendChild(rating);
        wrapper.appendChild(heading);

        priceEl.parentNode.insertBefore(wrapper, priceEl);

        heading.style.fontSize = '1.5rem';
        heading.style.fontWeight = '400';
        heading.style.fontFamily = '"Red Hat Display", sans-serif';
        heading.style.letterSpacing = '-0.03em';
      }

      // ✅ Move custom-color
      // const allVariant = document.querySelector('all-variant');
      // if (allVariant) {
      //   document.querySelectorAll('.custom-color').forEach(div => {
      //     if (!div.closest('accordion-custom')) {
      //       allVariant.parentNode.insertBefore(div, allVariant);
      //     }
      //   });
      // }

      // ✅ Move accordions
      const description = document.querySelector('.product__description');
      const accordions = document.querySelectorAll('accordion-custom');

      if (description && accordions.length) {
        accordions.forEach(acc => {
          description.insertAdjacentElement('afterend', acc);
        });
      }

      // ✅ Hide elements
      document.querySelectorAll('product-price').forEach(el => {
        el.style.display = 'none';
      });

      document.querySelectorAll('.text-block--background').forEach(el => {
        el.style.display = 'none';
      });
      clearInterval(timer);
      console.log('cleared ✅');
    }
  }, 50);

  // const optisTimer = setInterval(() => {
  //   const variantSelects = document.querySelector('livearf-variant-selects');
  //   const optisPicker = document.querySelector('optis-variant-picker');

  //   if (variantSelects && optisPicker) {

  //     if (!optisPicker.dataset.moved) {
  //       variantSelects.parentNode.insertBefore(optisPicker, variantSelects);
  //       optisPicker.dataset.moved = "true";
  //       console.log('optis moved ✅');
  //     }
  //     document.querySelectorAll('.se-selected-value.se-active').forEach(el => {
  //       el.style.display = 'none';
  //     });
  //     clearInterval(optisTimer);
  //   }

  // }, 100);

  const avadaTimer = setInterval(() => {
    const fieldset = document.querySelector('fieldset[name="Material"]');
    const legend = fieldset?.querySelector('legend');
    const button = document.querySelector('.Avada-inline-button');

    if (fieldset && legend && button && !button.dataset.moved) {
      // ✅ Wrap legend + button in flex container
      let wrapper = legend.parentNode.querySelector('.legend-inline-wrapper');

      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'legend-inline-wrapper';
        wrapper.style.display = 'flex';
        wrapper.style.alignItems = 'center';
        wrapper.style.justifyContent = 'space-between';

        legend.parentNode.insertBefore(wrapper, legend);
        wrapper.appendChild(legend);
      }

      // ✅ Move button next to legend
      wrapper.appendChild(button);

      // Optional spacing
      button.style.marginLeft = '10px';
      button.style.cursor = 'pointer';

      button.dataset.moved = "true";
      clearInterval(avadaTimer);
    }
  }, 100);

  const variantLabelTimer = setInterval(() => {
    const fieldsets = document.querySelectorAll('all-variant fieldset');

    if (fieldsets.length) {
      fieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector('legend');
        if (!legend) return;

        let span = fieldset.querySelector('.selected-value-label');
        if (!span) {
          span = document.createElement('span');
          span.className = 'selected-value-label';
          span.style.display = 'block';
          span.style.fontSize = '0.9rem';

          legend.insertAdjacentElement('afterend', span);
        }

        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) {
          console.log('checked value', checked.value)
          span.textContent = checked.value;
        }
      });
      clearInterval(variantLabelTimer);
    }
  }, 100);


  document.addEventListener('change', function (e) {
    if (!e.target.closest('all-variant')) return;

    const fieldset = e.target.closest('fieldset');
    const span = fieldset?.querySelector('.selected-value-label');
    if (span) {
      span.textContent = e.target.value;
    }
  });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.Avada-inline-button');
    if (!btn) return;
    const modal = document.querySelector('#Avada-SC__Modal');
    if (modal) {
      modal.classList.add('Avada-Modal__Show');
    }
  });
}

function updateAddToCartState() {
  const soldOutMsg = document.getElementById("soldOut");
  const addToCartBtn = document.querySelector(".product-form__submit");

  if (!addToCartBtn) return;
  addToCartBtn.classList.toggle(
    "disabled-cart",
    soldOutMsg && !soldOutMsg.classList.contains("hideBlock")
  );
}
updateAddToCartState()
document.addEventListener("change", function (e) {
  if (
    e.target.closest("variant-selects") ||
    e.target.closest("livearf-variant-selects")
  ) {
    setTimeout(() => {
      updateAddToCartState();
    }, 50);
  }
});